import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { AxiosResponse } from "axios";

/**
 * The advisor's read-only view of the selected company's VAT reports. Every endpoint needs the
 * Advisor relation; the reports show for a company with an external agency and Wint Accounting.
 */
const useVatReportService = () => {
  const { apiClientInstance } = useAPIClientHelper();

  /**
   * Errors stay silent: 403 (not an advisor) and 404 (backend not deployed yet) are ordinary "no" answers, and
   * this runs on the advisory view where a toast for either would be noise.
   */
  const getAvailability = (): Promise<WintSuperkollAPIModel.VatReportsAvailability> =>
    apiClientInstance(AuthEnums.AuthType.Company, { showErrors: false })
      .VatReportsClient.GetAvailability()
      .then((res) => res.data);

  /**
   * Newest period first; the server ignores ordering and caps a page at 12 rows. Returns the raw
   * response because `TableAsync` reads the paging envelope, not just the rows.
   */
  const listReports = (
    baseFilter: WintUtilsWebApi.Filter
  ): Promise<AxiosResponse<WintUtilsWebApi.ListResponse<WintSuperkollAPIModel.VatReportSummary>>> =>
    apiClientInstance(AuthEnums.AuthType.Company).VatReportsClient.List(baseFilter);

  const getReport = (id: string): Promise<WintSuperkollAPIModel.VatReportDetails> =>
    apiClientInstance(AuthEnums.AuthType.Company)
      .VatReportsClient.GetById(id)
      .then((res) => res.data);

  return { getAvailability, listReports, getReport };
};

export default useVatReportService;
